import * as React from 'react'

import { Box, Icon, Link, Text, useToggle } from '@factorialco/deprecated-design-system'
import { ProfileEmployeeAccessFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { observer } from 'mobx-react'

import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import ManageAccessModal from 'modules/employees/components/blocks/EmployeeStatusBanner/ManageAccessModal'
import { EmployeeStatusBannerEmployee } from 'modules/employees/components/blocks/EmployeeStatusBanner/types'

interface Props {
  access: ProfileEmployeeAccessFragment
  employee: EmployeeStatusBannerEmployee
  contractStartDate?: string
  setOnboardingProcessCreated: React.Dispatch<React.SetStateAction<string | undefined>>
}

const InvitationAcceptedWithoutOnboarding = ({
  access,
  employee,
  contractStartDate,
  setOnboardingProcessCreated,
}: Props) => {
  const [openManageAccessModal, toggleManageAccessModal] = useToggle(false)

  return (
    <Box paddingBottom="s32" paddingX="s64">
      <Box
        borderRadius={{ all: 'abs016' }}
        background="viridian100"
        padding="s12"
        paddingLeft="s16"
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
      >
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" width="full">
          <Box gap="s12" flexDirection="row" alignItems="center" paddingRight="s64">
            <Box background="viridian1000" borderRadius={{ all: 'abs008' }} padding="s2">
              <Icon.Medium icon="lightbulb" color="grey000White" />
            </Box>
            <Text.Normal weight="medium">
              {i18n.t('employees.creation.invitation_accepted.without_onboarding', {
                employee_name: employee.fullName,
                start_date: contractStartDate
                  ? i18nDateToString(moment(contractStartDate), 'ui')
                  : '',
              })}
            </Text.Normal>
          </Box>
          <Box flexNoShrink>
            <Link.Touchable onClick={toggleManageAccessModal(true)}>
              {i18n.t('employees.creation.invitation_accepted.buttons.manage_access')}
            </Link.Touchable>
          </Box>
        </Box>
      </Box>
      {openManageAccessModal && (
        <Box width="full">
          <ManageAccessModal
            access={access}
            employee={employee}
            onClose={toggleManageAccessModal(false)}
            setOnboardingProcessCreated={setOnboardingProcessCreated}
          />
        </Box>
      )}
    </Box>
  )
}

export default observer(InvitationAcceptedWithoutOnboarding)
